<script>
  import { onMount, afterUpdate } from 'svelte';
  import { formulList, gostergeList, degerAdd, degerUpdate } from '../../Api.svelte';
  import { degerlerStore, selectedDeger, isDegerEditing, selectedDegerlerDegerSayisi } from "../../stores/stores";
  import { getGostergeData } from '../../mw/check';


  let _id = null;
  let degerEditing = false;
  let gostergeler = [];
  let formuller = [];
  let selectedDegerGosterge = '';
  let veriler = [];
  let veriadi = [];
  let vDeger = [];
  let formulyaz = '';

  let degerler = [];
  let currentYear = new Date().getFullYear();
  let years = [];
  let dynamicPattern='';


  $:if (selectedDegerGosterge) {
    // vDeger = []; // Burada vDeger'ı sıfırlıyoruz
    // veriadi = [];
    updateselectedDegerlerDegerSayisi();
  } 

  function updateselectedDegerlerDegerSayisi(){
    const gosterge = gostergeler.find(g => g._id === selectedDegerGosterge);
    const formul = formuller.find(f => f.gosterge_id === selectedDegerGosterge);
    veriadi = (gosterge?.deger_sayisi > 1 && formul) ? formul.degiskenler : ["deger"];
    vDeger = veriadi.map((_, index) => vDeger[index] || '');
    selectedDegerlerDegerSayisi.set(gostergeler.deger_sayisi);
    dynamicPattern = (veriadi.length > 1) ? "^-?\\d*(\\.\\d+)?$" : "^[A-Za-z0-9%₺.,\\s-_]+$";

    formulyaz=(formul) ? formul.formul : "Bu Gösterge için Formul Yazılmamış";    
    }

  function watchSelectedDeger(newValue, oldValue) {
    updateselectedDegerlerDegerSayisi();
  }

  afterUpdate(() => {
    watchSelectedDeger();
}, [selectedDegerGosterge]);

  selectedDeger.subscribe(sdeger => {
    if (sdeger) {
      _id = sdeger._id;
      selectedDegerGosterge = sdeger.gosterge_id;
      yil = sdeger.yil;
      veriler = [...sdeger.veriler];
      vDeger = veriler.map(v => Object.values(v)[0]); // vDeger'ı verilerden alınan değerlerle başlat
    }
  });

  isDegerEditing.subscribe(sdeger => {
    degerEditing = sdeger;
  });

  degerlerStore.subscribe(sdeger => {
    degerler = sdeger;
  });

  async function submitForm() {
    if (degerEditing) {
      await updateDeger();
    } else {
      await addDeger();
    }
  }

  async function addDeger() {
    const veriler = createVerilerArray();
    console.log(veriler);
    const result = await degerAdd(selectedDegerGosterge, yil, veriler);
    if (result) {
      resetForm();
      degerlerStore.set(result);
    } else {
      console.error('Deger ekleme başarısız.');
    }
  }

  async function updateDeger() {
    const veriler = createVerilerArray();
    const result = await degerUpdate(_id, selectedDegerGosterge, yil, veriler);
    if (result) {
      degerlerStore.set(result);
      resetForm();
    } else {
      console.error('Deger güncelleme başarısız.');
    }
  }

  function resetForm() {
    _id = null;
    selectedDegerGosterge = '';
    yil = '';
    veriler = [];
    vDeger = [];
    isDegerEditing.set(false);
    selectedDeger.set(null);
  }

  onMount(async () => {
    gostergeler = await gostergeList();
    gostergeler = await getGostergeData(gostergeler);
    formuller = await formulList();
    years = Array.from({ length: 6 }, (_, index) => currentYear - 4 + index);
  });

  let yil = currentYear;
  yil=yil-1;

  function createVerilerArray() {
    if (veriadi.length > 1) {
      return veriadi.map((veri, index) => ({ [veri]: vDeger[index] }));
    } else {
      return [{ deger: vDeger[0] }];
    }
  }

</script>

<div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 class="font-semibold text-lg text-blueGray-700">
          {degerEditing ? 'Değer Düzenle' : 'Değer Ekle'} <span class="text-red-500 text-xs">***Göstergede Değişken Sayısı 1 için otomatik deger olarak atanmaktadır.</span>
        </h3>
      </div>
    </div>
  </div>
  <div class="block w-full overflow-x-auto">
    <form on:submit|preventDefault={submitForm}>
      <div class="px-6 py-4">
        <div class="flex flex-wrap -mx-4">
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block text-blueGray-600  font-bold mb-2" for="grid-password">
                Gösterge Seçiniz
                
              </label>
              <div class="relative">
                <select class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline" bind:value={selectedDegerGosterge} required>
                  <option value="" disabled hidden>Seçiniz</option>
                  {#each gostergeler as gosterge}
                    <option value={gosterge._id}>{gosterge.name}</option>
                  {/each}
                </select>
              </div>
              {#if $selectedDegerlerDegerSayisi}
                <div class="mt-4">
                  <p>Seçilen göstergenin Değişken Sayısı: {$selectedDegerlerDegerSayisi}</p>
                </div>
              {/if}
            </div>
          </div>
          <div class="relative w-full lg:w-6/12 mb-3">
            <label class="block text-blueGray-600  font-bold mb-2" for="grid-password">
              Yıl Seçiniz
            </label>
            <div class="relative">
              <select class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline" bind:value={yil} required>
                <option value="" disabled hidden>Seçiniz</option>
                {#each years as year}
                  <option value={year} selected={year === (currentYear)}>{year}</option>
                {/each}
              </select>
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block  text-blueGray-600 font-bold mb-2" for="grid-password">
                Veri Giriniz
              </label>
              {#each veriadi as veri, index}
              <div class="mb-2 flex items-end text-left">
                <label class="min-w-48 block text-blueGray-600 font-bold mb-2  " for="grid-password">
                  {veri} :
                </label>
                <input 
                  type="text" 
                  class="min-w-48 ml-2 border px-3 py-2 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring" 
                  bind:value={vDeger[index]} 
                  required
                  pattern={dynamicPattern}
                />
              </div>             
              {/each}
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block  text-blueGray-600 font-bold mb-2" for="grid-password">
                Formül Hesaplama : <br>
                {formulyaz}
  
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end">
          <button class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" on:click={resetForm}>
            {degerEditing ? 'İptal' : 'Temizle'}
          </button>
          <button class="bg-emerald-500 text-white active:bg-blueGray-400 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="submit">
            {degerEditing ? 'Güncelle' : 'Ekle'}
          </button>
        </div>

      </div>

    </form>
  </div>
</div>
